<template>
  <ul
    class="mb-12 grid grid-cols-2 gap-x-8 gap-y-6 text-sm text-white md:mb-0 md:flex"
  >
    <li v-for="(menuItem, i) in menu" :key="i">
      <UiLink
        :to="menuItem.url"
        class="inline-block border-b-[1px] border-white"
      >
        {{ menuItem.name }}
      </UiLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
interface Props {
  menu?: any[];
}

withDefaults(defineProps<Props>(), {
  menu: () => [],
});
</script>
